/* Progressive enhancement: forms and product links work without JavaScript. */
(() => {
  let selectSequence = 0;
  function caseGiftCopy() {
    const source = document.querySelector('[data-rr-gift-copy]');
    if (!source) return null;
    try { return JSON.parse(source.textContent); } catch { return null; }
  }
  function updateCaseSelection(section) {
    const copy = caseGiftCopy();
    const select = section.querySelector('[data-rr-variant]');
    const notice = section.querySelector('[data-rr-case-selection]');
    if (!copy || !select || !notice) return;
    const caseOption = Array.from(select.options).find(option => copy.eligible_variants.includes(option.value));
    const hasCase = Boolean(caseOption);
    notice.hidden = !hasCase;
    if (!hasCase) return;
    const eligible = copy.eligible_variants.includes(select.value);
    const unit = copy.eligible_units?.[caseOption.value];
    const available = caseOption.dataset.available === 'true';
    const message = !available ? (copy['unavailable_' + unit] || copy.unavailable) : eligible ? (copy['selected_' + unit] || copy.selected) : (copy['unselected_' + unit] || copy.unselected);
    if (notice.textContent !== message) notice.textContent = message;
    notice.dataset.eligible = String(eligible && available);
  }
  function clarifyCaseWidget() {
    const copy = caseGiftCopy();
    if (!copy) return;
    const write = (element, value) => { if (element && element.textContent.trim() !== value) element.textContent = value; };
    document.querySelectorAll('.salepify-embed-widget__item[rule-id]').forEach(rule => {
      if (rule.getAttribute('rule-id') !== copy.rule) return;
      const container = rule.closest('.salepify-embed-widget__embedded-list-container');
      if (container && !container.classList.contains('rr-case-offer')) container.classList.add('rr-case-offer');
      if (container?.querySelectorAll('[rule-id]').length === 1) write(container.querySelector('.salepify-embed-widget__header-title'), copy.title);
      const caseOption = Array.from(document.querySelector('[data-rr-variant]')?.options || []).find(option => copy.eligible_variants.includes(option.value));
      const unit = copy.eligible_units?.[caseOption?.value];
      write(rule.querySelector('.salepify-embed-widget__header-text'), copy['requirement_' + unit] || copy.requirement);
      write(rule.querySelector('.salepify-embed-widget__header-badge'), copy.badge);
      write(rule.querySelector('.salepify-embed-widget__upsell-message[data-state="not_met"]'), copy.not_met);
    });
  }
  let caseObserver;
  function observeCaseWidget() {
    clarifyCaseWidget();
    if (caseObserver || !document.body || !caseGiftCopy()) return;
    let queued = false;
    caseObserver = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      queueMicrotask(() => { queued = false; clarifyCaseWidget(); });
    });
    caseObserver.observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['class','data-state']});
  }
  function enhanceSelect(select) {
    if (select.dataset.rrEnhanced || select.multiple) return;
    select.dataset.rrEnhanced = 'true';
    const wrap = document.createElement('div');
    wrap.className = 'rr-select';
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'rr-select-trigger';
    button.setAttribute('role', 'combobox');
    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false');
    const value = document.createElement('span');
    const arrow = document.createElement('span');
    arrow.className = 'rr-select-arrow';
    arrow.setAttribute('aria-hidden', 'true');
    button.append(value, arrow);
    const list = document.createElement('ul');
    list.className = 'rr-select-options';
    list.id = `rr-select-${++selectSequence}`;
    list.hidden = true;
    list.setAttribute('role', 'listbox');
    const label = select.getAttribute('aria-label') || select.labels?.[0]?.textContent?.trim() || '';
    button.setAttribute('aria-label', label);
    list.setAttribute('aria-label', label);
    button.setAttribute('aria-controls', list.id);
    select.before(wrap);
    wrap.append(select, button, list);
    select.classList.add('rr-select-native');
    select.tabIndex = -1;
    select.setAttribute('aria-hidden', 'true');
    let active = select.selectedIndex;
    let searchText = '';
    let lastTyped = 0;
    const options = [...select.options];
    const rows = options.map((option, index) => {
      const row = document.createElement('li');
      row.id = `${list.id}-${index}`;
      row.tabIndex = -1;
      row.setAttribute('role', 'option');
      row.setAttribute('aria-disabled', String(option.disabled));
      row.textContent = option.textContent;
      list.append(row);
      // Keep focus on the combobox until click selects the option.
      // Otherwise a non-focusable option can blur the trigger and close early.
      row.addEventListener('pointerdown', event => event.preventDefault());
      row.addEventListener('click', () => { if (!option.disabled) choose(index); });
      return row;
    });
    const highlight = index => {
      active = index;
      rows.forEach((row, i) => row.classList.toggle('is-active', i === active));
      if (rows[active]) {
        button.setAttribute('aria-activedescendant', rows[active].id);
        if (!list.hidden) rows[active].scrollIntoView({block: 'nearest'});
      }
    };
    const sync = () => {
      value.textContent = select.options[select.selectedIndex]?.textContent || '';
      button.disabled = select.disabled;
      rows.forEach((row, i) => row.setAttribute('aria-selected', String(i === select.selectedIndex)));
      if (list.hidden) active = select.selectedIndex;
    };
    const close = () => {
      list.hidden = true;
      button.setAttribute('aria-expanded', 'false');
      button.removeAttribute('aria-activedescendant');
      wrap.classList.remove('is-open');
    };
    const open = () => {
      document.querySelectorAll('.rr-select.is-open').forEach(other => { if (other !== wrap) other.dispatchEvent(new Event('rr:close')); });
      wrap.classList.toggle('rr-select--above', button.getBoundingClientRect().bottom > window.innerHeight - 240 && button.getBoundingClientRect().top > 240);
      list.hidden = false;
      wrap.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      highlight(select.selectedIndex);
    };
    function choose(index) {
      select.selectedIndex = index;
      select.dispatchEvent(new Event('input', {bubbles: true}));
      select.dispatchEvent(new Event('change', {bubbles: true}));
      sync();
      close();
      button.focus();
    }
    const move = delta => {
      let index = active;
      for (let tries = 0; tries < options.length; tries++) {
        index = (index + delta + options.length) % options.length;
        if (!options[index].disabled) { highlight(index); return; }
      }
    };
    button.addEventListener('click', () => list.hidden ? open() : close());
    button.addEventListener('keydown', event => {
      if (event.key === 'Escape') { close(); return; }
      if (event.key === 'Tab') { close(); return; }
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        if (list.hidden) open(); else if (options[active] && !options[active].disabled) choose(active);
        return;
      }
      if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
        event.preventDefault();
        const wasClosed = list.hidden;
        if (wasClosed) open();
        if (event.key === 'Home') { highlight(0); if (options[0]?.disabled) move(1); }
        else if (event.key === 'End') { highlight(options.length - 1); if (options[active]?.disabled) move(-1); }
        else if (!wasClosed) move(event.key === 'ArrowDown' ? 1 : -1);
        return;
      }
      if (event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
        const now = Date.now();
        searchText = (now - lastTyped > 700 ? '' : searchText) + event.key.toLocaleLowerCase();
        lastTyped = now;
        const match = options.findIndex(option => !option.disabled && option.textContent.trim().toLocaleLowerCase().startsWith(searchText));
        if (match >= 0) { if (list.hidden) open(); highlight(match); }
      }
    });
    wrap.addEventListener('rr:close', close);
    wrap.addEventListener('focusout', event => { if (event.relatedTarget && !wrap.contains(event.relatedTarget)) close(); });
    select.addEventListener('change', sync);
    select.form?.addEventListener('reset', () => requestAnimationFrame(sync));
    select.labels?.forEach(labelElement => labelElement.addEventListener('click', event => { event.preventDefault(); button.focus(); }));
    sync();
  }
  document.addEventListener('pointerdown', event => document.querySelectorAll('.rr-select.is-open').forEach(wrap => { if (!wrap.contains(event.target)) wrap.dispatchEvent(new Event('rr:close')); }));
  document.addEventListener('pointerdown', event => document.querySelectorAll('[data-rr-menu][open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; }));
  function init(root = document) {
    const cartCase = root.querySelector('[data-rr-cart-case]');
    if (cartCase) {
      const copy = caseGiftCopy();
      const qualifyingRow = [...root.querySelectorAll('[data-rr-cart-variant]')].find(row => Number(row.dataset.rrCartQuantity) > 0 && copy?.eligible_variants.includes(row.dataset.rrCartVariant));
      cartCase.hidden = !qualifyingRow;
      const link = cartCase.querySelector('[data-rr-cart-case-link]');
      const productLink = qualifyingRow?.querySelector('[data-rr-cart-product]');
      if (productLink && link) link.href = productLink.href;
    }
    root.querySelectorAll('[data-rr-catalog]').forEach(catalog => {
      if (catalog.dataset.ready) return;
      catalog.dataset.ready = 'true';
      const cards = [...catalog.querySelectorAll('[data-rr-card]')];
      const kind = catalog.querySelector('[data-rr-kind]');
      const search = catalog.querySelector('[data-rr-search]');
      const stock = catalog.querySelector('[data-rr-stock]');
      const sort = catalog.querySelector('[data-rr-sort]');
      const count = catalog.querySelector('[data-rr-count]');
      const empty = catalog.querySelector('[data-rr-empty]');
      const grid = catalog.querySelector('[data-rr-grid]');
      const productGroups = new Map([
        ['body', ['Body lotion', 'Body butter & cream', 'Body gloss', 'Petroleum jelly']],
        ['bath', ['Body wash', 'Cleanser', 'Glycerin']],
        ['hair', ['Conditioner', 'Hair & scalp care', 'Hair styling', 'Shampoo + conditioner', 'Shampoo']],
        ['sets', ['Sets']]
      ].flatMap(([group, types]) => types.map(type => [type, group])));
      const groupFor = card => productGroups.get(card.dataset.kind) || 'other';
      if (kind) ['body', 'bath', 'hair', 'sets', 'other'].forEach(group => {
        if (!cards.some(card => groupFor(card) === group)) return;
        const option = document.createElement('option');
        option.value = group;
        option.textContent = kind.dataset[group + 'Label'] || group;
        kind.append(option);
      });
      const apply = () => {
        let visible = 0;
        const query = (search?.value || '').trim().toLocaleLowerCase();
        cards.forEach(card => {
          const show = (!kind?.value || groupFor(card) === kind.value) && (!stock?.checked || card.dataset.available === 'true') && (!query || card.dataset.search.toLocaleLowerCase().includes(query));
          card.hidden = !show; if (show) visible++;
        });
        if (count) count.textContent = `${visible} ${visible === 1 ? (count.dataset.one || 'product') : (count.dataset.many || 'products')}`;
        if (empty) empty.hidden = visible > 0;
        if (sort && grid) {
          const ordered = cards.slice();
          if (sort.value === 'price-up') ordered.sort((a,b) => Number(a.dataset.price)-Number(b.dataset.price));
          else if (sort.value === 'price-down') ordered.sort((a,b) => Number(b.dataset.price)-Number(a.dataset.price));
          else if (sort.value === 'az') ordered.sort((a,b) => a.dataset.title.localeCompare(b.dataset.title));
          else ordered.sort((a,b) => Number(a.dataset.order)-Number(b.dataset.order));
          ordered.forEach(card => grid.append(card));
        }
      };
      [kind, search, stock, sort].filter(Boolean).forEach(el => el.addEventListener(el === search ? 'input' : 'change', apply));
      apply();
    });
    root.querySelectorAll('[data-rr-product]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const select = section.querySelector('[data-rr-variant]');
      const price = section.querySelector('[data-rr-price]');
      const buy = section.querySelector('[data-rr-buy]');
      const main = section.querySelector('[data-rr-main-image]');
      const sync = () => {
        if (!select) return;
        const option = select.options[select.selectedIndex];
        const available = option.dataset.available === 'true';
        if (price) price.textContent = option.dataset.price;
        if (buy) { buy.disabled = !available; buy.textContent = available ? 'Add to bag' : 'Sold out'; }
        if (main && option.dataset.image) {
          main.src = option.dataset.image;
          main.removeAttribute('srcset');
          main.classList.remove('rr-image-detail');
          if (option.dataset.alt) main.alt = option.dataset.alt;
          section.querySelectorAll('[data-rr-thumbnail]').forEach(thumbnail => thumbnail.setAttribute('aria-pressed', String(thumbnail.dataset.mode !== 'detail' && thumbnail.dataset.image === option.dataset.image)));
        }
        const url = new URL(location.href); url.searchParams.set('variant',option.value); history.replaceState({},'',url);
        updateCaseSelection(section);
      };
      select?.addEventListener('change',sync);
      updateCaseSelection(section);
      section.querySelectorAll('[data-rr-thumbnail]').forEach(button => button.addEventListener('click', () => {
        if (!main) return;
        main.src = button.dataset.image; main.removeAttribute('srcset'); main.alt = button.dataset.alt || '';
        main.classList.toggle('rr-image-detail', button.dataset.mode === 'detail');
        section.querySelectorAll('[data-rr-thumbnail]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      }));
    });
    root.querySelectorAll('[data-rr-menu]').forEach(menu => {
      if (menu.dataset.ready) return; menu.dataset.ready = 'true';
      menu.addEventListener('keydown',event => {if(event.key==='Escape'){event.stopPropagation();menu.open=false;menu.querySelector('summary').focus();}});
      menu.addEventListener('focusout', event => { if (event.relatedTarget && !menu.contains(event.relatedTarget)) menu.open = false; });
    });
    root.querySelectorAll('.rr-filters select, .rr-product-form select').forEach(enhanceSelect);
    observeCaseWidget();
    root.querySelectorAll('.rr-tabs, .rr-desktop-links, .rr-menu-panel nav').forEach(tabs => {
      const current = new URL(location.href);
      tabs.querySelectorAll('a').forEach(link => {
        const destination = new URL(link.href, current);
        if (destination.origin === current.origin && destination.pathname === current.pathname && (!destination.hash || destination.hash === current.hash) && destination.searchParams.get('view') === current.searchParams.get('view')) link.setAttribute('aria-current', 'page');
        else link.removeAttribute('aria-current');
      });
    });
    root.querySelectorAll('.rr-collections-menu, .rr-mobile-collections').forEach(menu => {
      menu.dataset.current = String(Boolean(menu.querySelector('a[aria-current="page"]')));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load',event => init(event.target));
  document.addEventListener('rr:cart-updated', () => init());
})();
